module.exports = __webpack_public_path__ + "static/portfolio_gallery_4-15ef6f240b05142a8e9a6ea714a2c5d4.jpg";